export const selectTaxonomyTemplates = (state) => state.taxonomyTemplates.taxonomyTemplates;
export const selectTaxonomyTemplatesLoading = (state) => state.taxonomyTemplates.loading;